import { Builder } from '@builder.io/sdk';
import { BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES } from '../BuilderComponentsName';

import {
  textColorOptionsLimited,
  backgroundGradientOptions,
} from '../utils/builderColorOptions';
import { getBackgroundGradientInput, getPaddingInputs, getBackgroundColorInput } from '../utils/builderSharedInputs';
import { S14WhatToExpectSection } from '../components/interactive-sections/S14WhatToExpect';

Builder.registerComponent(S14WhatToExpectSection, {
  name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S14WhatToExpect,
  friendlyName: 'S14 What To Expect',
  inputs: [
    {
      name: 'headline',
      type: 'string',
      required: true,
      defaultValue: 'Pre-Treatment Prep: Get the Most from Your Laser Treatments',
      friendlyName: 'Headline',
      helperText: 'Main headline text for the section',
    },
    {
      name: 'headlineColor',
      type: 'string',
      friendlyName: 'Headline Color',
      enum: textColorOptionsLimited,
      defaultValue: 'Blue',
      helperText: 'Select a color for the headline text'
    },
    {
      name: 'copyText',
      type: 'string',
      required: true,
      defaultValue: 'Before your first treatment, complete a free consultation. Our experts will assess your skin type and hair color, review your medical history, and learn about your goals. To get the best results and safest treatments, here’s how to prep for laser hair removal: ',
      friendlyName: 'Text',
      helperText: 'Main text content for the section',
    },
    {
      name: 'copyTextColor',
      type: 'string',
      friendlyName: 'Text Color',
      enum: textColorOptionsLimited,
      defaultValue: 'Navy',
      helperText: 'Select a color for the copy text content'
    },
    {
      name: 'images',
      type: 'list',
      friendlyName: 'Images',
      helperText: 'Add images with captions and alt text for the section',
      onChange: (options) => {
        // Check if the list has more than 8 items
        if (options.get('images').length > 8) {
          options.set('images', options.get('images').slice(0, 8))
          alert('maximum items are 8, delete items to continue')
        }
        // check if the list has less than 4 items
        if (options.get('images').length < 4) {
          alert('minimum items are 4, add items to continue')
        }
      },
      subFields: [
        {
          name: 'url',
          type: 'file',
          friendlyName: 'Image',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'gif', 'svg'],
          required: true,
          helperText: 'Upload an image or provide an image URL',
        },
        {
          name: 'caption',
          type: 'string',
          friendlyName: 'Caption',
          required: true,
          helperText: 'Caption text for this image',
          defaultValue: 'Image Caption'
        },
        {
          name: 'altText',
          type: 'string',
          friendlyName: 'Alt Text',
          required: true,
          helperText: 'Alt text for this image',
          defaultValue: 'Image Alt Text'
        }
      ],
      defaultValue: [
        {
          url: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F1a39eb3bcdae4737af24499de1952fdc',
          caption: 'Don’t pluck or wax! Plucking, waxing, epilating, and sugaring temporarily remove hair follicles, leaving nothing for the laser to eliminate. ',
          altText: 'Image Alt Text 1'
        },
        {
          url: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2Fe68ee86e970f446e8637f221d229dc08',
          caption: 'Apply a cool compress or aloe vera: Place on the treated area to reduce mild redness or swelling.',
          altText: 'Image Alt Text 2'
        },
        {
          url: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F812b3d3344634bd8afedf0545304ac19',
          caption: 'Targets and removes unwanted hair at the source.',
          altText: 'Image Alt Text 3'
        },
        {
          url: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2Fcfde502c67404be8ab5611e3f6420244',
          caption: 'Avoid sun exposure: Sunburn can cause skin irritation and delay results.',
          altText: 'Image Alt Text 4'
        }
      ]
    },
    {
      name: 'imageCaptionTextColor',
      type: 'string',
      friendlyName: 'Image Caption Text Color',
      enum: textColorOptionsLimited,
      defaultValue: 'Blue',
      helperText: 'Select a color for the image caption text'
    },
    ...getBackgroundColorInput({
      defaultValue: 'White',
    }),
    ...getBackgroundGradientInput({
      backgroundGradientList: backgroundGradientOptions,
    }),
    {
      name: 'backgroundImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
      friendlyName: 'Background Image',
      helperText: 'Upload an image to use as the section background'
    },
    ...getPaddingInputs({
      desktopTop: 'large',
      desktopBottom: 'large',
      mobileTop: 'small',
      mobileBottom: 'small',
    }),
  ]
});
